import { Observable } from "rxjs";

export const ALLOWED_UPLOAD_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
  "image/tiff",
  "image/tif",
  "application/pdf",
] as const;

export const ALLOWED_RASTER_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
] as const;

export type AllowedUploadImageMimeType =
  (typeof ALLOWED_UPLOAD_IMAGE_MIME_TYPES)[number];

export interface Image {
  file: File;
  width?: number;
  height?: number;
  previewUrl?: string;
  uploadData?: unknown;
}

export type ImageUploadFn = (
  file: File,
) => Observable<string | { previewUrl: string; uploadData?: unknown }>;
